var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 65,
    viewBox: "0 0 60 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5714 8.43723H47.1429V1.89619C47.1429 1.06258 46.4233 0.386719 45.5357 0.386719H40.1786C39.291 0.386719 38.5714 1.06258 38.5714 1.89619V8.43723H21.4286V1.89619C21.4286 1.06258 20.709 0.386719 19.8214 0.386719H14.4643C13.5767 0.386719 12.8571 1.06258 12.8571 1.89619V8.43723H6.42857C2.87812 8.43723 0 11.1404 0 14.4751V58.7529C0 62.0876 2.87812 64.7908 6.42857 64.7908H53.5714C57.1219 64.7908 60 62.0876 60 58.7529V14.4751C60 11.1404 57.1219 8.43723 53.5714 8.43723ZM52.7679 58.7529H7.23214C7.01902 58.7529 6.81463 58.6734 6.66393 58.5319C6.51323 58.3903 6.42857 58.1984 6.42857 57.9982V20.513H53.5714V57.9982C53.5714 58.1984 53.4868 58.3903 53.3361 58.5319C53.1854 58.6734 52.981 58.7529 52.7679 58.7529ZM45.6899 33.5133L26.6306 51.2709C26.0005 51.8579 24.9829 51.8542 24.3577 51.2623L14.3009 41.7402C13.6758 41.1484 13.6799 40.1926 14.31 39.6054L17.3527 36.7706C17.9829 36.1836 19.0004 36.1874 19.6255 36.7793L25.5323 42.372L40.408 28.5124C41.0381 27.9254 42.0557 27.9292 42.6809 28.521L45.6991 31.3787C46.3242 31.9705 46.32 32.9263 45.6899 33.5133Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.5e420900f8c71c839f34b37cbe444a75.svg";
export { ForwardRef as ReactComponent };